import React from 'react';
import WalletButton from './WalletButton';
import '../styles/navbar.css';

export default function Navbar({ onNotify }) {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/logo.png" alt="CLUSTER" className="logo-img" />
        <span className="logo-text">CLUSTER</span>
      </div>
      <WalletButton onNotify={onNotify} />
    </nav>
  );
}
